<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Profil</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Profil Mahasiswa</h2>
                <p class="page-subtitle">Informasi Data Diri & Status Dokumen</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-md-8 col-lg-5">
                    
                    <!-- Profile Card -->
                    <div class="profile-card">
                        <!-- Profile Header with Photo -->
                        <div class="profile-header">
                            <img :src="photo" class="profile-photo" alt="Profile Photo">
                        </div>
                        
                        <!-- Profile Body -->
                        <div class="profile-body">
                            <button @click="openAlert()" class="btn-edit">
                                <i class="fa fa-edit"></i> UBAH PROFIL
                            </button>
                            
                            <div class="profile-divider"></div>
                            
                            <div class="profile-id">{{biodata.student_id}}</div>
                            
                            <p class="profile-name">{{biodata.firstname_rumi}} {{biodata.lastname_rumi}}</p>
                            <p class="profile-name-arabic font-majalla" dir="rtl">{{biodata.firstname_jawi}} {{biodata.familyname_jawi}} {{biodata.lastname_jawi}}</p>
                            
                            <p class="profile-info">{{biodata.cityzen_id}}</p>
                            <p class="profile-info">{{faculty}} {{department}}</p>
                        </div>
                        
                        <div class="profile-divider"></div>
                        
                        <!-- Status Section -->
                        <div class="status-section">
                            <h6 class="status-title">Status Dokumen</h6>
                            
                            <div class="status-badge-wrapper">
                                <div class="status-badge" :class="[biodata.syahadah != '' && biodata.syahadah != null ? 'success' : 'warning']">
                                    <span>Syahadah 3 Tsanawi</span>
                                    <i :class="[biodata.syahadah != '' && biodata.syahadah != null ? 'fas fa-check-circle' : 'fas fa-clock']"></i>
                                </div>
                                <button 
                                    v-if="biodata.syahadah != '' && biodata.syahadah != null" 
                                    @click="previewDocument('syahadah', biodata.syahadah)"
                                    class="btn-preview-doc"
                                    type="button"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            
                            <div class="status-badge-wrapper">
                                <div class="status-badge" :class="[biodata.senaraidapur != '' && biodata.senaraidapur != null ? 'success' : 'warning']">
                                    <span>Senarai Dapur</span>
                                    <i :class="[biodata.senaraidapur != '' && biodata.senaraidapur != null ? 'fas fa-check-circle' : 'fas fa-clock']"></i>
                                </div>
                                <button 
                                    v-if="biodata.senaraidapur != '' && biodata.senaraidapur != null" 
                                    @click="previewDocument('senaraidapur', biodata.senaraidapur)"
                                    class="btn-preview-doc"
                                    type="button"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            
                            <div class="status-badge-wrapper">
                                <div class="status-badge" :class="[biodata.kadpengenalan != '' && biodata.kadpengenalan != null ? 'success' : 'warning']">
                                    <span>Kad Pengenalan</span>
                                    <i :class="[biodata.kadpengenalan != '' && biodata.kadpengenalan != null ? 'fas fa-check-circle' : 'fas fa-clock']"></i>
                                </div>
                                <button 
                                    v-if="biodata.kadpengenalan != '' && biodata.kadpengenalan != null" 
                                    @click="previewDocument('kadpengenalan', biodata.kadpengenalan)"
                                    class="btn-preview-doc"
                                    type="button"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            
                            <div class="status-badge-wrapper kasfu-nilai-group">
                                <div class="status-badge" :class="[transcriptFiles.length > 0 ? 'success' : 'warning']">
                                    <span>Kasfu Nilai</span>
                                    <span v-if="transcriptFiles.length > 0" class="badge badge-light ml-1">{{ transcriptFiles.length }}</span>
                                    <i :class="[transcriptFiles.length > 0 ? 'fas fa-check-circle' : 'fas fa-clock']"></i>
                                </div>
                                <div v-if="transcriptFiles.length > 0" class="transcript-previews">
                                    <div v-for="(file, index) in transcriptFiles" :key="file.id" class="transcript-file-item">
                                        <button 
                                            @click="previewDocument('kasyfunilai', file.name)"
                                            class="btn-preview-doc"
                                            type="button"
                                            :title="'Lihat file ' + (index + 1)"
                                        >
                                            <i class="fas fa-eye"></i>
                                            <span class="preview-index">{{ index + 1 }}</span>
                                        </button>
                                        <button 
                                            @click.stop.prevent="deleteTranscriptFile(file.id, index)"
                                            class="btn-delete-transcript"
                                            type="button"
                                            :title="'Hapus file ' + (index + 1)"
                                            :disabled="deletingTranscript"
                                        >
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="status-badge-wrapper">
                                <div class="status-badge" :class="[biodata.passport_file ? 'success' : 'warning']">
                                    <span>Passport</span>
                                    <i :class="[biodata.passport_file ? 'fas fa-check-circle' : 'fas fa-clock']"></i>
                                </div>
                                <button 
                                    v-if="biodata.passport_file" 
                                    @click="previewDocument('passport', biodata.passport_file)"
                                    class="btn-preview-doc"
                                    type="button"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            
                            <button @click="evedanceUploadForm()" class="btn-upload">
                                <i class="fa fa-upload"></i>
                                Upload Dokumen
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Edit Profile Modal -->
        <div class="modal fade modal-theme" id="edit-profile-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="editProfileModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editProfileModalLabel">
                            <i class="fas fa-user-edit mr-2"></i> Ubah Profil
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Success Message -->
                        <div v-if="editSuccess" class="alert alert-success mb-3">
                            <i class="fas fa-check-circle"></i> Data profil berhasil diperbarui!
                        </div>
                        <!-- Error Message -->
                        <!-- <div v-if="editError" class="alert alert-danger mb-3">
                            <i class="fas fa-exclamation-triangle"></i> {{ editError }}
                        </div> -->
                        
                        <form @submit.prevent="saveProfile()">
                            <!-- Nama Jawi/Arab Section -->
                            <h6 class="text-muted mb-3"><i class="fas fa-globe-asia mr-1"></i> Nama (Arab) <span class="text-danger">*</span></h6>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group text-right">
                                        <label class="col-form-label font-majalla">نام</label>
                                        <input type="text" class="form-control font-majalla" dir="rtl" :class="{'is-invalid': editErrors.firstname_jawi}"
                                            v-model="editForm.firstname_jawi">
                                        <span class="text-danger" v-if="editErrors.firstname_jawi">
                                            {{ editErrors.firstname_jawi[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group text-right">
                                        <label class="col-form-label font-majalla">بن \ بنت</label>
                                        <input type="text" class="form-control font-majalla" dir="rtl" :class="{'is-invalid': editErrors.familyname_jawi}"
                                            v-model="editForm.familyname_jawi">
                                        <span class="text-danger" v-if="editErrors.familyname_jawi">
                                            {{ editErrors.familyname_jawi[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group text-right">
                                        <label class="col-form-label font-majalla">نسب</label>
                                        <input type="text" class="form-control font-majalla" dir="rtl" :class="{'is-invalid': editErrors.lastname_jawi}"
                                            v-model="editForm.lastname_jawi">
                                        <span class="text-danger" v-if="editErrors.lastname_jawi">
                                            {{ editErrors.lastname_jawi[0] }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Nama English Section -->
                            <h6 class="text-muted mb-3 mt-3"><i class="fas fa-globe mr-1"></i> Nama (English) <span class="text-danger">*</span></h6>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">First Name</label>
                                        <input type="text" class="form-control" :class="{'is-invalid': editErrors.firstname_rumi}"
                                            v-model="editForm.firstname_rumi"
                                            placeholder="First Name">
                                        <span class="text-danger" v-if="editErrors.firstname_rumi">
                                            {{ editErrors.firstname_rumi[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">Last Name</label>
                                        <input type="text" class="form-control" :class="{'is-invalid': editErrors.lastname_rumi}"
                                            v-model="editForm.lastname_rumi"
                                            placeholder="Last Name">
                                        <span class="text-danger" v-if="editErrors.lastname_rumi">
                                            {{ editErrors.lastname_rumi[0] }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Nama Thai Section -->
                            <h6 class="text-muted mb-3 mt-3"><i class="fas fa-flag mr-1"></i> Nama (Thai) <span class="text-danger">*</span></h6>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">ชื่อ (First Name)</label>
                                        <input type="text" class="form-control" :class="{'is-invalid': editErrors.firstname_thai}"
                                            v-model="editForm.firstname_thai"
                                            placeholder="ชื่อ">
                                        <span class="text-danger" v-if="editErrors.firstname_thai">
                                            {{ editErrors.firstname_thai[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label">นามสกุล (Last Name)</label>
                                        <input type="text" class="form-control" :class="{'is-invalid': editErrors.lastname_thai}"
                                            v-model="editForm.lastname_thai"
                                            placeholder="นามสกุล">
                                        <span class="text-danger" v-if="editErrors.lastname_thai">
                                            {{ editErrors.lastname_thai[0] }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            <hr class="my-4">
                            
                            <!-- Other Info Section -->
                            <h6 class="text-muted mb-3"><i class="fas fa-info-circle mr-1"></i> Informasi Lain</h6>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">Tarikh Lahir</label>
                                        <input type="date" class="form-control"
                                            v-model="editForm.birth_date">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">
                                            Email 
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <input type="email" class="form-control"
                                            :class="{'is-invalid': editErrors.email}"
                                            v-model="editForm.email"
                                            placeholder="Masukkan email">
                                        <div v-if="editErrors.email" class="text-danger small mt-1">
                                            {{ editErrors.email[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">No. Telefon</label>
                                        <input type="tel" class="form-control"
                                            :class="{'is-invalid': editErrors.telephone}"
                                            v-model="editForm.telephone"
                                            placeholder="Masukkan no. telefon">
                                        <div v-if="editErrors.telephone" class="text-danger small mt-1">
                                            {{ editErrors.telephone[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <hr class="my-4">
                            
                            <!-- Address Section -->
                            <h6 class="text-muted mb-3"><i class="fas fa-map-marker-alt mr-1"></i> Alamat</h6>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label">No. Rumah</label>
                                        <input type="text" class="form-control"
                                            v-model="editForm.house_number"
                                            placeholder="No. Rumah">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label">Nama Kampung</label>
                                        <input type="text" class="form-control"
                                            v-model="editForm.village_name"
                                            placeholder="Nama Kampung">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label">Jalan</label>
                                        <input type="text" class="form-control"
                                            v-model="editForm.road"
                                            placeholder="Nama Jalan">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label">Tempat/Lokasi</label>
                                        <input type="text" class="form-control"
                                            v-model="editForm.place"
                                            placeholder="Tempat/Lokasi">
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="col-form-label">Poskod</label>
                                        <input type="text" class="form-control"
                                            v-model="editForm.post"
                                            placeholder="Poskod">
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Province/District/Subdistrict Cascading Selects -->
                            <h6 class="text-muted mb-3"><i class="fas fa-map-marked-alt mr-1"></i> ที่อยู่ (Location) <span class="text-danger">*</span></h6>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">จังหวัด (Province)</label>
                                        <v-select
                                            v-model="selectedProvince"
                                            :options="provinces"
                                            label="PROVINCE_NAME"
                                            :reduce="prov => prov.PROVINCE_ID"
                                            placeholder="-- Cari Province --"
                                            @input="onProvinceChange"
                                            :class="{'is-invalid': editErrors.province_id}"
                                        ></v-select>
                                        <span class="text-danger" v-if="editErrors.province_id">
                                            {{ editErrors.province_id[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">อำเภอ (District)</label>
                                        <v-select
                                            v-model="selectedDistrict"
                                            :options="districts"
                                            label="AMPHUR_NAME"
                                            :reduce="dist => dist.AMPHUR_ID"
                                            placeholder="-- Cari District --"
                                            :disabled="!selectedProvince"
                                            @input="onDistrictChange"
                                            :class="{'is-invalid': editErrors.district_id}"
                                        ></v-select>
                                        <span class="text-danger" v-if="editErrors.district_id">
                                            {{ editErrors.district_id[0] }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="col-form-label font-weight-bold">ตำบล (Subdistrict)</label>
                                        <v-select
                                            v-model="selectedSubdistrict"
                                            :options="subdistricts"
                                            label="DISTRICT_NAME"
                                            :reduce="sub => sub.DISTRICT_ID"
                                            placeholder="-- Cari Subdistrict --"
                                            :disabled="!selectedDistrict"
                                            @input="onSubdistrictChange"
                                            :class="{'is-invalid': editErrors.subdistrict_id}"
                                        ></v-select>
                                        <span class="text-danger" v-if="editErrors.subdistrict_id">
                                            {{ editErrors.subdistrict_id[0] }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4">
                                <button :disabled="editSaving" type="submit" class="btn-submit">
                                    <i v-if="editSaving" class="fas fa-spinner fa-spin mr-1"></i>
                                    <i v-else class="fas fa-save mr-1"></i>
                                    {{ editSaving ? 'Menyimpan...' : 'Simpan' }}
                                </button>
                                <button type="button" class="btn btn-secondary ml-2" data-dismiss="modal">Batal</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Evidence Upload Modal -->
        <div class="modal fade modal-theme" id="evedance-form-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="uploadModalLabel">
                            <i class="fas fa-cloud-upload-alt mr-2"></i> Upload Dokumen
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- General Error Message -->
                        <div v-if="uploadError" class="alert alert-danger mb-3">
                            <i class="fas fa-exclamation-triangle mr-2"></i>{{ uploadError }}
                        </div>
                        
                        <p class="text-muted small mb-3">
                            <i class="fas fa-info-circle mr-1"></i>
                            Pilih minimal satu dokumen. Format: JPG, JPEG, PNG (maks. 1.5MB, auto-resize jika lebih besar)
                        </p>
                        
                        <form ref="uploadForm" @submit.prevent="uploadEvedance()" enctype="multipart/form-data">
                            <!-- Resizing Indicator -->
                            <div v-if="resizing" class="alert alert-info mb-3 d-flex align-items-center">
                                <i class="fas fa-spinner fa-spin mr-2"></i>
                                <span>Sedang mengompresi gambar...</span>
                            </div>
                            
                            <div class="form-group">
                                <label class="col-form-label font-weight-bold">Salinan Syahadah</label>
                                <input type="file" class="form-control"
                                    :class="{'is-invalid': serverError.syahadah}"
                                    @change="changeSyahadah"
                                    accept="image/jpeg,image/jpg,image/png"
                                    :disabled="resizing">
                                <div v-if="fileInfo.syahadah" class="file-size-info mt-1">
                                    <span class="badge badge-secondary">{{ fileInfo.syahadah.originalSize }}</span>
                                    <template v-if="fileInfo.syahadah.wasCompressed">
                                        <i class="fas fa-arrow-right mx-1"></i>
                                        <span class="badge badge-success">{{ fileInfo.syahadah.compressedSize }}</span>
                                        <span class="text-success small ml-1">(dikurangkan {{ fileInfo.syahadah.savedPercent }})</span>
                                    </template>
                                    <span v-else class="text-muted small ml-1">(tidak perlu resize)</span>
                                </div>
                                <div v-if="serverError.syahadah" class="text-danger small mt-1">
                                    {{serverError.syahadah[0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label font-weight-bold">
                                    Salinan Kasfu Nilai 
                                    <span class="text-muted small">(boleh pilih beberapa file)</span>
                                </label>
                                <input type="file" class="form-control"
                                    :class="{'is-invalid': serverError.kasyfunilai || serverError['kasyfunilai.0']}"
                                    @change="changeKasyfuNilai"
                                    accept="image/jpeg,image/jpg,image/png"
                                    :disabled="resizing"
                                    multiple>
                                <div v-if="fileInfo.kasyfunilai && fileInfo.kasyfunilai.length > 0" class="file-size-info mt-1">
                                    <div v-for="(info, index) in fileInfo.kasyfunilai" :key="index" class="mb-1">
                                        <span class="badge badge-secondary">File {{ index + 1 }}: {{ info.originalSize }}</span>
                                        <template v-if="info.wasCompressed">
                                            <i class="fas fa-arrow-right mx-1"></i>
                                            <span class="badge badge-success">{{ info.compressedSize }}</span>
                                            <span class="text-success small ml-1">(dikurangkan {{ info.savedPercent }})</span>
                                        </template>
                                        <span v-else class="text-muted small ml-1">(tidak perlu resize)</span>
                                    </div>
                                </div>
                                <div v-if="serverError.kasyfunilai" class="text-danger small mt-1">
                                    {{serverError.kasyfunilai[0]}}
                                </div>
                                <div v-if="serverError['kasyfunilai.0']" class="text-danger small mt-1">
                                    {{serverError['kasyfunilai.0'][0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label font-weight-bold">Salinan Senarai Dapur</label>
                                <input type="file" class="form-control"
                                    :class="{'is-invalid': serverError.senaraidapur}"
                                    @change="changeSenaraiDapur"
                                    accept="image/jpeg,image/jpg,image/png"
                                    :disabled="resizing">
                                <div v-if="fileInfo.senaraidapur" class="file-size-info mt-1">
                                    <span class="badge badge-secondary">{{ fileInfo.senaraidapur.originalSize }}</span>
                                    <template v-if="fileInfo.senaraidapur.wasCompressed">
                                        <i class="fas fa-arrow-right mx-1"></i>
                                        <span class="badge badge-success">{{ fileInfo.senaraidapur.compressedSize }}</span>
                                        <span class="text-success small ml-1">(dikurangkan {{ fileInfo.senaraidapur.savedPercent }})</span>
                                    </template>
                                    <span v-else class="text-muted small ml-1">(tidak perlu resize)</span>
                                </div>
                                <div v-if="serverError.senaraidapur" class="text-danger small mt-1">
                                    {{serverError.senaraidapur[0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label font-weight-bold">Salinan Kad Pengenalan</label>
                                <input type="file" class="form-control"
                                    :class="{'is-invalid': serverError.kadpengenalan}"
                                    @change="changeKadPengenalan"
                                    accept="image/jpeg,image/jpg,image/png"
                                    :disabled="resizing">
                                <div v-if="fileInfo.kadpengenalan" class="file-size-info mt-1">
                                    <span class="badge badge-secondary">{{ fileInfo.kadpengenalan.originalSize }}</span>
                                    <template v-if="fileInfo.kadpengenalan.wasCompressed">
                                        <i class="fas fa-arrow-right mx-1"></i>
                                        <span class="badge badge-success">{{ fileInfo.kadpengenalan.compressedSize }}</span>
                                        <span class="text-success small ml-1">(dikurangkan {{ fileInfo.kadpengenalan.savedPercent }})</span>
                                    </template>
                                    <span v-else class="text-muted small ml-1">(tidak perlu resize)</span>
                                </div>
                                <div v-if="serverError.kadpengenalan" class="text-danger small mt-1">
                                    {{serverError.kadpengenalan[0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label font-weight-bold">Salinan Passport</label>
                                <input type="file" class="form-control"
                                    :class="{'is-invalid': serverError.passport}"
                                    @change="changePassport"
                                    accept="image/jpeg,image/jpg,image/png"
                                    :disabled="resizing">
                                <div v-if="fileInfo.passport" class="file-size-info mt-1">
                                    <span class="badge badge-secondary">{{ fileInfo.passport.originalSize }}</span>
                                    <template v-if="fileInfo.passport.wasCompressed">
                                        <i class="fas fa-arrow-right mx-1"></i>
                                        <span class="badge badge-success">{{ fileInfo.passport.compressedSize }}</span>
                                        <span class="text-success small ml-1">(dikurangkan {{ fileInfo.passport.savedPercent }})</span>
                                    </template>
                                    <span v-else class="text-muted small ml-1">(tidak perlu resize)</span>
                                </div>
                                <div v-if="serverError.passport" class="text-danger small mt-1">
                                    {{serverError.passport[0]}}
                                </div>
                            </div>
                            <div class="mt-4">
                                <button :disabled="disabled || resizing" type="submit" class="btn-submit">
                                    <i class="fas fa-upload mr-1"></i> Upload
                                </button>
                                <span v-if="disabled" class="ml-2 text-muted small">
                                    <i class="fas fa-spinner fa-spin"></i> Sedang upload...
                                </span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enhanced Lightbox Preview with Zoom & Pan -->
        <div 
            v-if="showPreview" 
            class="lightbox-overlay" 
            @click.self="closePreview"
            @wheel.prevent="handleLightboxWheel"
        >
            <!-- Close Button -->
            <button class="lightbox-close" @click="closePreview">
                <i class="fas fa-times"></i>
            </button>
            
            <!-- Toolbar -->
            <div class="lightbox-toolbar">
                <span class="lightbox-title">{{ previewTitle }}</span>
                <div class="zoom-controls">
                    <button type="button" class="btn-zoom" @click="zoomOut" :disabled="lightbox.zoom <= 0.5">
                        <i class="fas fa-search-minus"></i>
                    </button>
                    <button 
                        type="button" 
                        class="btn-zoom zoom-level-btn" 
                        @click="resetZoom"
                        title="Reset Zoom"
                    >
                        {{ Math.round(lightbox.zoom * 100) }}%
                    </button>
                    <button type="button" class="btn-zoom" @click="zoomIn" :disabled="lightbox.zoom >= 5">
                        <i class="fas fa-search-plus"></i>
                    </button>
                    <a :href="previewUrl" target="_blank" class="btn-zoom" title="Buka di Tab Baru">
                        <i class="fas fa-external-link-alt"></i>
                    </a>
                </div>
            </div>
            
            <!-- Zoom hint -->
            <p class="lightbox-hint">Double-klik atau scroll untuk zoom • Drag untuk geser</p>
            
            <!-- Image Container with Drag Support -->
            <div 
                class="lightbox-content"
                :class="{ 'cursor-grab': lightbox.zoom > 1, 'cursor-grabbing': lightbox.isDragging }"
                @mousedown="startDrag"
                @mousemove="onDrag"
                @mouseup="endDrag"
                @mouseleave="endDrag"
                @touchstart.prevent="handleTouchStart"
                @touchmove.prevent="handleTouchMove"
                @touchend="handleTouchEnd"
            >
                <img 
                    :src="previewUrl" 
                    class="lightbox-image"
                    alt="Preview Dokumen"
                    :style="lightboxImageStyle"
                    @dblclick="handleDoubleClick"
                    draggable="false"
                >
            </div>
        </div>
    </div>
</template>

<script>
    // import BiodataForm from './BiodataForm.vue'
    import $ from "jquery";
    import http from '@/services/BackendService'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'
    export default {
        components:{
            // 'biodata-form': BiodataForm
            'v-select': vSelect
        },
        mounted(){
            this.retreiveBiodata()
            window.addEventListener('keyup', this.handleEscKey)
        },
        beforeUnmount() {
            window.removeEventListener('keyup', this.handleEscKey)
        },
        computed: {
            lightboxImageStyle() {
                return {
                    transform: `scale(${this.lightbox.zoom}) translate(${this.lightbox.translateX}px, ${this.lightbox.translateY}px)`,
                    transition: this.lightbox.isDragging ? 'none' : 'transform 0.1s ease'
                }
            }
        },
        data(){
            return{
                biodata: {
                    student_id: 'xxxxxxxx',
                    firstname_rumi: '',
                    lastname_rumi: '',
                    firstname_jawi: '',
                    lastname_jawi: '',
                    familyname_jawi: '',
                    email: '',
                    cityzen_id: '',

                    citizen_book: '',
                    id_book: '',
                    transcript: '',

                },
                photo: 'male.png',
                faculty: '',
                department: '',
                //file upload
                syahadah: '',
                syahadah_url: '',
                kasyfunilai: [], // Array for multiple files
                senaraidapur: '',
                kadpengenalan: '',
                passport: '',
                transcriptFiles: [], // List of transcript files from API
                // File resize info for each document
                fileInfo: {
                    syahadah: null,
                    kasyfunilai: [], // Array for multiple files
                    senaraidapur: null,
                    kadpengenalan: null,
                    passport: null
                },
                resizing: false,
                deletingTranscript: false,
                //server errors
                serverError: {},
                uploadError: '',
                disabled: false,
                // Edit profile form
                editForm: {
                    email: '',
                    telephone: '',
                    // Address fields
                    house_number: '',
                    village_name: '',
                    road: '',
                    place: '',
                    post: '',
                    province_id: '',
                    district_id: '',
                    subdistrict_id: '',
                    // Name fields
                    firstname_jawi: '',
                    lastname_jawi: '',
                    familyname_jawi: '',
                    firstname_rumi: '',
                    lastname_rumi: '',
                    firstname_thai: '',
                    lastname_thai: '',
                    // Birth date
                    birth_date: ''
                },
                // Location data for selects
                provinces: [],
                districts: [],
                subdistricts: [],
                // Selected values for v-select
                selectedProvince: null,
                selectedDistrict: null,
                selectedSubdistrict: null,
                editErrors: {},
                editError: '',
                editSuccess: false,
                editSaving: false,
                // Document preview base URL
                documentBaseUrl: 'https://kisda.online/photo/studentEvedence/confirmed/',
                // Document preview - Enhanced lightbox state
                showPreview: false,
                previewUrl: '',
                previewTitle: '',
                lightbox: {
                    zoom: 1,
                    translateX: 0,
                    translateY: 0,
                    isDragging: false,
                    startX: 0,
                    startY: 0
                },
                lastTouchDistance: null
            }
        },
        methods:{
            uploadEvedance(){
                // Reset errors
                this.uploadError = ''
                this.serverError = {}
                
                // Validate at least one file is selected
                const hasKasyfunilai = this.kasyfunilai && this.kasyfunilai.length > 0
                const hasFile = this.syahadah || hasKasyfunilai || this.senaraidapur || this.kadpengenalan || this.passport
                if (!hasFile) {
                    this.uploadError = 'Sila pilih minimal satu dokumen untuk di-upload'
                    return
                }
                
                // Validate file types (images only)
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
                const singleFiles = [
                    { name: 'Syahadah', file: this.syahadah },
                    { name: 'Senarai Dapur', file: this.senaraidapur },
                    { name: 'Kad Pengenalan', file: this.kadpengenalan },
                    { name: 'Passport', file: this.passport }
                ]
                
                for (const item of singleFiles) {
                    if (item.file && !allowedTypes.includes(item.file.type)) {
                        this.uploadError = `${item.name}: Hanya file gambar (JPG, JPEG, PNG) yang dibenarkan`
                        return
                    }
                }
                
                // Validate kasyfunilai files (array)
                for (let i = 0; i < this.kasyfunilai.length; i++) {
                    if (!allowedTypes.includes(this.kasyfunilai[i].type)) {
                        this.uploadError = `Kasfu Nilai file ${i+1}: Hanya file gambar (JPG, JPEG, PNG) yang dibenarkan`
                        return
                    }
                }
                
                this.disabled = true
                this.$Progress.start()
                let data = new FormData()
                data.append('syahadah', this.syahadah)
                // Append multiple kasyfunilai files
                for (let i = 0; i < this.kasyfunilai.length; i++) {
                    data.append('kasyfunilai[]', this.kasyfunilai[i])
                }
                data.append('senaraidapur', this.senaraidapur)
                data.append('kadpengenalan', this.kadpengenalan)
                data.append('passport', this.passport)
                http.post(`profile/evedanceUpload`, data)
                    .then(() => {
                        this.disabled = false
                        this.$Progress.finish()
                        $("#evedance-form-modal").modal("hide")
                        this.syahadah = ''
                        this.kasyfunilai = []
                        this.senaraidapur = ''
                        this.kadpengenalan = ''
                        this.passport = ''
                        this.serverError = {}
                        this.uploadError = ''
                        // Reset file info
                        this.fileInfo = {
                            syahadah: null,
                            kasyfunilai: [],
                            senaraidapur: null,
                            kadpengenalan: null,
                            passport: null
                        }
                        // Reset form file inputs
                        if (this.$refs.uploadForm) {
                            this.$refs.uploadForm.reset()
                        }
                        // Refresh biodata to update status badges
                        this.retreiveBiodata()
                    })
                    .catch(error => {
                        this.$Progress.fail()
                        if (error.response && error.response.data) {
                            this.serverError = error.response.data.errors || {}
                            if (error.response.data.message) {
                                this.uploadError = error.response.data.message
                            }
                        }
                        this.disabled = false
                    })

            },
            // Image compression utility
            async compressImage(file, maxSizeKB = 1536) {
                // maxSizeKB = 1536 KB = 1.5 MB
                return new Promise((resolve) => {
                    // If file is already under max size, return as is
                    if (file.size <= maxSizeKB * 1024) {
                        resolve(file)
                        return
                    }
                    
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        const img = new Image()
                        img.onload = () => {
                            const canvas = document.createElement('canvas')
                            let width = img.width
                            let height = img.height
                            
                            // Calculate scale factor based on file size
                            // Reduce dimensions proportionally
                            const scaleFactor = Math.sqrt((maxSizeKB * 1024) / file.size)
                            width = Math.floor(width * scaleFactor)
                            height = Math.floor(height * scaleFactor)
                            
                            // Ensure minimum dimensions
                            width = Math.max(width, 200)
                            height = Math.max(height, 200)
                            
                            canvas.width = width
                            canvas.height = height
                            
                            const ctx = canvas.getContext('2d')
                            ctx.drawImage(img, 0, 0, width, height)
                            
                            // Convert to blob with quality adjustment
                            let quality = 0.8
                            const tryCompress = () => {
                                canvas.toBlob((blob) => {
                                    if (blob.size > maxSizeKB * 1024 && quality > 0.3) {
                                        quality -= 0.1
                                        tryCompress()
                                    } else {
                                        // Create new File from blob
                                        const compressedFile = new File([blob], file.name, {
                                            type: 'image/jpeg',
                                            lastModified: Date.now()
                                        })
                                        resolve(compressedFile)
                                    }
                                }, 'image/jpeg', quality)
                            }
                            tryCompress()
                        }
                        img.src = e.target.result
                    }
                    reader.readAsDataURL(file)
                })
            },
            // Helper function to format file size
            formatFileSize(bytes) {
                if (bytes < 1024) return bytes + ' B'
                if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
                return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
            },
            async changeSyahadah(e) {
                const file = e.target.files[0]
                if (file) {
                    const originalSize = file.size
                    this.resizing = true
                    this.fileInfo.syahadah = null
                    
                    const compressed = await this.compressImage(file)
                    this.syahadah = compressed
                    
                    const wasCompressed = compressed.size < originalSize
                    this.fileInfo.syahadah = {
                        originalSize: this.formatFileSize(originalSize),
                        compressedSize: this.formatFileSize(compressed.size),
                        wasCompressed: wasCompressed,
                        savedPercent: wasCompressed ? Math.round((1 - compressed.size / originalSize) * 100) + '%' : '0%'
                    }
                    this.resizing = false
                }
            },
            async changeKasyfuNilai(e) {
                const files = e.target.files
                if (files && files.length > 0) {
                    this.resizing = true
                    this.kasyfunilai = []
                    this.fileInfo.kasyfunilai = []
                    
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i]
                        const originalSize = file.size
                        
                        const compressed = await this.compressImage(file)
                        this.kasyfunilai.push(compressed)
                        
                        const wasCompressed = compressed.size < originalSize
                        this.fileInfo.kasyfunilai.push({
                            originalSize: this.formatFileSize(originalSize),
                            compressedSize: this.formatFileSize(compressed.size),
                            wasCompressed: wasCompressed,
                            savedPercent: wasCompressed ? Math.round((1 - compressed.size / originalSize) * 100) + '%' : '0%'
                        })
                    }
                    
                    this.resizing = false
                }
            },
            async changeSenaraiDapur(e) {
                const file = e.target.files[0]
                if (file) {
                    const originalSize = file.size
                    this.resizing = true
                    this.fileInfo.senaraidapur = null
                    
                    const compressed = await this.compressImage(file)
                    this.senaraidapur = compressed
                    
                    const wasCompressed = compressed.size < originalSize
                    this.fileInfo.senaraidapur = {
                        originalSize: this.formatFileSize(originalSize),
                        compressedSize: this.formatFileSize(compressed.size),
                        wasCompressed: wasCompressed,
                        savedPercent: wasCompressed ? Math.round((1 - compressed.size / originalSize) * 100) + '%' : '0%'
                    }
                    this.resizing = false
                }
            },
            async changeKadPengenalan(e) {
                const file = e.target.files[0]
                if (file) {
                    const originalSize = file.size
                    this.resizing = true
                    this.fileInfo.kadpengenalan = null
                    
                    const compressed = await this.compressImage(file)
                    this.kadpengenalan = compressed
                    
                    const wasCompressed = compressed.size < originalSize
                    this.fileInfo.kadpengenalan = {
                        originalSize: this.formatFileSize(originalSize),
                        compressedSize: this.formatFileSize(compressed.size),
                        wasCompressed: wasCompressed,
                        savedPercent: wasCompressed ? Math.round((1 - compressed.size / originalSize) * 100) + '%' : '0%'
                    }
                    this.resizing = false
                }
            },
            async changePassport(e) {
                const file = e.target.files[0]
                if (file) {
                    const originalSize = file.size
                    this.resizing = true
                    this.fileInfo.passport = null
                    
                    const compressed = await this.compressImage(file)
                    this.passport = compressed
                    
                    const wasCompressed = compressed.size < originalSize
                    this.fileInfo.passport = {
                        originalSize: this.formatFileSize(originalSize),
                        compressedSize: this.formatFileSize(compressed.size),
                        wasCompressed: wasCompressed,
                        savedPercent: wasCompressed ? Math.round((1 - compressed.size / originalSize) * 100) + '%' : '0%'
                    }
                    this.resizing = false
                }
            },
            evedanceUploadForm(){
                $("#evedance-form-modal").modal("show")
            },
            // Delete transcript file
            async deleteTranscriptFile(fileId, index) {
                const result = await this.$swal.fire({
                    title: 'Hapus Kasfu Nilai?',
                    text: 'File yang dihapus tidak dapat dikembalikan.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Ya, Hapus!',
                    cancelButtonText: 'Batal'
                })
                
                if (!result.isConfirmed) {
                    return
                }
                
                this.deletingTranscript = true
                try {
                    await http.delete(`profile/transcript/${fileId}`)
                    // Remove from local array
                    this.transcriptFiles.splice(index, 1)
                    this.$swal.fire({
                        title: 'Berhasil!',
                        text: 'File berhasil dihapus.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false
                    })
                } catch (error) {
                    console.error('Delete error:', error)
                    this.$swal.fire({
                        title: 'Gagal!',
                        text: 'Gagal menghapus file. Sila coba lagi.',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                } finally {
                    this.deletingTranscript = false
                }
            },
            openAlert(){
                // Open edit profile modal and populate form
                this.editForm.email = this.biodata.email || ''
                this.editForm.telephone = this.biodata.telephone || ''
                // Address fields
                this.editForm.house_number = this.biodata.house_number || ''
                this.editForm.village_name = this.biodata.t_village_name || ''
                this.editForm.road = this.biodata.t_road || ''
                this.editForm.place = this.biodata.place || ''
                this.editForm.post = this.biodata.post || ''
                this.editForm.province_id = this.biodata.t_province || ''
                this.editForm.district_id = this.biodata.t_district || ''
                this.editForm.subdistrict_id = this.biodata.t_subdistrict || ''
                // Set selected values for v-select
                this.selectedProvince = this.biodata.t_province || null
                this.selectedDistrict = this.biodata.t_district || null
                this.selectedSubdistrict = this.biodata.t_subdistrict || null
                // Name fields
                this.editForm.firstname_jawi = this.biodata.firstname_jawi || ''
                this.editForm.lastname_jawi = this.biodata.lastname_jawi || ''
                this.editForm.familyname_jawi = this.biodata.familyname_jawi || ''
                this.editForm.firstname_rumi = this.biodata.firstname_rumi || ''
                this.editForm.lastname_rumi = this.biodata.lastname_rumi || ''
                this.editForm.firstname_thai = this.biodata.t_studentname || ''
                this.editForm.lastname_thai = this.biodata.t_studentlastname || ''
                // Birth date - format to YYYY-MM-DD for HTML date input
                this.editForm.birth_date = this.biodata.birdth_date ? this.biodata.birdth_date.substring(0, 10) : ''
                this.editErrors = {}
                this.editError = ''
                this.editSuccess = false
                
                // Load provinces
                this.loadProvinces()
                
                // If province is set, load districts
                if (this.editForm.province_id) {
                    this.loadDistricts(this.editForm.province_id)
                }
                // If district is set, load subdistricts
                if (this.editForm.district_id) {
                    this.loadSubdistricts(this.editForm.district_id)
                }
                
                $("#edit-profile-modal").modal("show")
            },
            // Load all provinces
            loadProvinces(){
                http.get('profile/provinces')
                    .then(response => {
                        if (response.data.success) {
                            this.provinces = response.data.data
                        }
                    })
                    .catch(() => {
                        this.provinces = []
                    })
            },
            // Load districts by province
            loadDistricts(provinceId){
                http.get(`profile/districts/${provinceId}`)
                    .then(response => {
                        if (response.data.success) {
                            this.districts = response.data.data
                        }
                    })
                    .catch(() => {
                        this.districts = []
                    })
            },
            // Load subdistricts by district
            loadSubdistricts(districtId){
                http.get(`profile/subdistricts/${districtId}`)
                    .then(response => {
                        if (response.data.success) {
                            this.subdistricts = response.data.data
                        }
                    })
                    .catch(() => {
                        this.subdistricts = []
                    })
            },
            // Province change handler
            onProvinceChange(val){
                this.editForm.province_id = val || ''
                this.editForm.district_id = ''
                this.editForm.subdistrict_id = ''
                this.selectedDistrict = null
                this.selectedSubdistrict = null
                this.districts = []
                this.subdistricts = []
                if (val) {
                    this.loadDistricts(val)
                }
            },
            // District change handler
            onDistrictChange(val){
                this.editForm.district_id = val || ''
                this.editForm.subdistrict_id = ''
                this.selectedSubdistrict = null
                this.subdistricts = []
                if (val) {
                    this.loadSubdistricts(val)
                }
            },
            // Subdistrict change handler
            onSubdistrictChange(val){
                this.editForm.subdistrict_id = val || ''
            },
            saveProfile(){
                this.editSaving = true
                this.editErrors = {}
                this.editError = ''
                this.editSuccess = false
                this.$Progress.start()
                
                http.put('profile/update', this.editForm)
                    .then(response => {
                        this.editSaving = false
                        this.$Progress.finish()
                        if (response.data.success) {
                            this.editSuccess = true
                            // Update local biodata
                            this.biodata.email = this.editForm.email
                            this.biodata.telephone = this.editForm.telephone
                            this.biodata.place = this.editForm.address
                            // Close modal after 1.5 seconds
                            setTimeout(() => {
                                $("#edit-profile-modal").modal("hide")
                                this.editSuccess = false
                            }, 1500)
                            this.retreiveBiodata()
                        }
                    })
                    .catch(error => {
                        this.editSaving = false
                        this.$Progress.fail()
                        if (error.response && error.response.data) {
                            if (error.response.data.errors) {
                                this.editErrors = error.response.data.errors
                                // Show sweet alert with validation error
                                this.$swal({
                                    icon: 'error',
                                    title: 'Validation Error',
                                    text: 'Sila lengkapkan semua field yang wajib diisi',
                                    confirmButtonColor: '#2d6a4f'
                                })
                            } else if (error.response.data.message) {
                                this.editError = error.response.data.message
                                this.$swal({
                                    icon: 'error',
                                    title: 'Error',
                                    text: error.response.data.message,
                                    confirmButtonColor: '#2d6a4f'
                                })
                            } else {
                                this.editError = 'Terjadi kesalahan. Silakan coba lagi.'
                                this.$swal({
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Terjadi kesalahan. Silakan coba lagi.',
                                    confirmButtonColor: '#2d6a4f'
                                })
                            }
                        } else {
                            this.editError = 'Terjadi kesalahan. Silakan coba lagi.'
                            this.$swal({
                                icon: 'error',
                                title: 'Error',
                                text: 'Terjadi kesalahan. Silakan coba lagi.',
                                confirmButtonColor: '#2d6a4f'
                            })
                        }
                    })
            },
            retreiveBiodata(){
                this.$Progress.start()
                this.$store.dispatch('profile/retreiveBiodata')
                    .then(response => {
                        this.biodata = response.data.biodata
                        this.photo = "https://kisda.online/images/"+response.data.photo.images
                        this.faculty = response.data.faculty
                        this.department = response.data.department
                        // Store transcript files from API
                        this.transcriptFiles = response.data.transcript_files || []
                        this.$Progress.finish()
                    })
                    .catch(error => {
                        if(error.response.status == 401 || error.response.status == 419){
                            this.$store.dispatch("authentication/cencelAuthen")
                        }
                        this.$Progress.fail()
                    })
            },
            // Document Preview Methods
            previewDocument(docType, filename) {
                if (filename) {
                    // Set preview URL
                    this.previewUrl = this.documentBaseUrl + filename
                    
                    // Set title based on document type
                    const titles = {
                        'syahadah': 'Salinan Syahadah',
                        'senaraidapur': 'Salinan Senarai Dapur',
                        'kadpengenalan': 'Salinan Kad Pengenalan',
                        'passport': 'Salinan Passport'
                    }
                    this.previewTitle = titles[docType] || 'Dokumen'
                    
                    // Reset lightbox state
                    this.lightbox.zoom = 1
                    this.lightbox.translateX = 0
                    this.lightbox.translateY = 0
                    this.lightbox.isDragging = false
                    
                    // Show lightbox
                    this.showPreview = true
                    // Prevent body scroll
                    document.body.style.overflow = 'hidden'
                }
            },
            closePreview() {
                this.showPreview = false
                // Restore body scroll
                document.body.style.overflow = ''
            },
            // Zoom controls
            zoomIn() {
                if (this.lightbox.zoom < 5) {
                    this.lightbox.zoom = Math.min(5, this.lightbox.zoom + 0.5)
                }
            },
            zoomOut() {
                if (this.lightbox.zoom > 0.5) {
                    this.lightbox.zoom = Math.max(0.5, this.lightbox.zoom - 0.5)
                    // Reset position if zoom is back to 1 or less
                    if (this.lightbox.zoom <= 1) {
                        this.lightbox.translateX = 0
                        this.lightbox.translateY = 0
                    }
                }
            },
            resetZoom() {
                this.lightbox.zoom = 1
                this.lightbox.translateX = 0
                this.lightbox.translateY = 0
            },
            // Double-click zoom toggle
            handleDoubleClick() {
                if (this.lightbox.zoom === 1) {
                    this.lightbox.zoom = 2
                } else {
                    this.resetZoom()
                }
            },
            // Mouse wheel zoom
            handleLightboxWheel(event) {
                const delta = event.deltaY > 0 ? -0.25 : 0.25
                const newZoom = Math.max(0.5, Math.min(5, this.lightbox.zoom + delta))
                
                if (newZoom !== this.lightbox.zoom) {
                    this.lightbox.zoom = newZoom
                    // Reset position if zoom is 1 or less
                    if (newZoom <= 1) {
                        this.lightbox.translateX = 0
                        this.lightbox.translateY = 0
                    }
                }
            },
            // Drag/Pan functions
            startDrag(event) {
                if (this.lightbox.zoom <= 1) return
                this.lightbox.isDragging = true
                this.lightbox.startX = event.clientX - this.lightbox.translateX
                this.lightbox.startY = event.clientY - this.lightbox.translateY
            },
            onDrag(event) {
                if (!this.lightbox.isDragging || this.lightbox.zoom <= 1) return
                this.lightbox.translateX = event.clientX - this.lightbox.startX
                this.lightbox.translateY = event.clientY - this.lightbox.startY
            },
            endDrag() {
                this.lightbox.isDragging = false
            },
            // Touch support for mobile
            handleTouchStart(event) {
                if (event.touches.length === 1 && this.lightbox.zoom > 1) {
                    // Single finger drag
                    this.lightbox.isDragging = true
                    this.lightbox.startX = event.touches[0].clientX - this.lightbox.translateX
                    this.lightbox.startY = event.touches[0].clientY - this.lightbox.translateY
                } else if (event.touches.length === 2) {
                    // Two finger pinch-to-zoom
                    this.lightbox.isDragging = false
                    this.lastTouchDistance = this.getTouchDistance(event.touches)
                }
            },
            handleTouchMove(event) {
                if (event.touches.length === 1 && this.lightbox.isDragging && this.lightbox.zoom > 1) {
                    // Single finger drag
                    this.lightbox.translateX = event.touches[0].clientX - this.lightbox.startX
                    this.lightbox.translateY = event.touches[0].clientY - this.lightbox.startY
                } else if (event.touches.length === 2) {
                    // Pinch-to-zoom
                    const currentDistance = this.getTouchDistance(event.touches)
                    if (this.lastTouchDistance) {
                        const scale = currentDistance / this.lastTouchDistance
                        const newZoom = Math.max(0.5, Math.min(5, this.lightbox.zoom * scale))
                        this.lightbox.zoom = newZoom
                        
                        if (newZoom <= 1) {
                            this.lightbox.translateX = 0
                            this.lightbox.translateY = 0
                        }
                    }
                    this.lastTouchDistance = currentDistance
                }
            },
            handleTouchEnd() {
                this.lightbox.isDragging = false
                this.lastTouchDistance = null
            },
            getTouchDistance(touches) {
                const dx = touches[0].clientX - touches[1].clientX
                const dy = touches[0].clientY - touches[1].clientY
                return Math.sqrt(dx * dx + dy * dy)
            },
            // ESC key handler
            handleEscKey(event) {
                if (event.key === 'Escape' && this.showPreview) {
                    this.closePreview()
                }
            }
        }   
    }
</script>

<style scoped>
/* Fix v-select dropdown being cut off in modal */
/* .modal-body {
    overflow: visible !important;
}

.modal-content {
    overflow: visible !important;
} */

/* .v-select .vs__dropdown-menu {
    z-index: 9999 !important;
    max-height: 200px;
} */

/* Status Badge Wrapper */
.status-badge-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.status-badge-wrapper .status-badge {
    flex: 1;
    margin-bottom: 0;
}

/* Preview Document Button */
.btn-preview-doc {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(52, 152, 219, 0.1);
    color: #3498db;
    border: none;
    border-radius: 6px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.btn-preview-doc:hover {
    background: #3498db;
    color: #fff;
}

/* Transcript previews container */
.transcript-previews {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.transcript-file-item {
    display: flex;
    align-items: center;
    gap: 2px;
    background: rgba(0,0,0,0.03);
    border-radius: 6px;
    padding: 2px;
}

.preview-index {
    font-size: 0.65rem;
    font-weight: 600;
    margin-left: 2px;
}

.btn-delete-transcript {
    width: 20px;
    height: 20px;
    border: none;
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
    border-radius: 4px;
    font-size: 0.7rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.btn-delete-transcript:hover:not(:disabled) {
    background: #e74c3c;
    color: #fff;
}

.btn-delete-transcript:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Kasfu Nilai group with multiple previews */
.kasfu-nilai-group {
    flex-wrap: wrap;
}

/* Custom Lightbox */
.lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.95);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.lightbox-close {
    position: absolute;
    top: 15px;
    right: 20px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 1.2rem;
    cursor: pointer;
    z-index: 10001;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.lightbox-close:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.lightbox-toolbar {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 15px;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px 20px;
    border-radius: 30px;
    z-index: 10000;
}

.lightbox-title {
    color: #fff;
    font-weight: 600;
    font-size: 0.95rem;
}

.lightbox-hint {
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
    z-index: 10000;
    pointer-events: none;
}

.lightbox-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 90px 20px 20px;
    user-select: none;
}

.lightbox-content.cursor-grab {
    cursor: grab;
}

.lightbox-content.cursor-grabbing {
    cursor: grabbing;
}

.lightbox-image {
    max-width: 95vw;
    max-height: 85vh;
    object-fit: contain;
    display: block;
    transform-origin: center center;
}

/* Zoom Controls */
.zoom-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-zoom {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    text-decoration: none;
}

.btn-zoom.zoom-level-btn {
    width: auto;
    min-width: 55px;
    padding: 0 10px;
    border-radius: 18px;
    font-size: 0.85rem;
    font-weight: 600;
}

.btn-zoom:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
}

.btn-zoom:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

/* Responsive lightbox */
@media (max-width: 768px) {
    .lightbox-toolbar {
        flex-direction: column;
        gap: 10px;
        padding: 15px;
        width: calc(100% - 80px);
    }
    
    .lightbox-hint {
        top: auto;
        bottom: 20px;
    }
    
    .lightbox-content {
        padding: 140px 10px 50px;
    }
    
    .lightbox-image {
        max-width: 100%;
        max-height: 70vh;
    }
}
</style>